const mapPolicyRule = rule => ({
  id: rule.id,
  internal_id: rule.internal_id,
  name: rule.name,
  is_enabled: rule.is_enabled,
  action: rule.action,
  valid_from: rule.valid_from,
  valid_until: rule.valid_until,
  notes: rule.notes,
})

const mapSummary = summary => ({
  all: summary.all,
  current: summary.current,
  scheduled: summary.scheduled,
  expired: summary.expired,
})

export const transformResponseGetPolicyRules = data => ({
  count: data?.count,
  summary: data?.summary && mapSummary(data.summary),
  results: data?.results?.map(mapPolicyRule),
})
